import { Component, ViewChild } from '@angular/core';
import { TransportPickupListingComponent } from './transport-pickup-listing/transport-pickup-listing.component';

@Component({
  selector: 'app-transport-pickup',
  templateUrl: './transport-pickup.component.html',
  styleUrls: ['./transport-pickup.component.scss']
})
export class TransportPickupComponent {

  @ViewChild('transportPickupListing') transportPickupListingComponent!: TransportPickupListingComponent;

  onTransportPickupAdded(): void {
    console.log('Transport pickup added successfully');
    // Trigger refresh of the transport pickup listing
    if (this.transportPickupListingComponent) {
      this.transportPickupListingComponent.onTransportPickupAdded();
    }
  }

  onTransportPickupUpdated(): void {
    console.log('Transport pickup updated successfully');
    // Trigger refresh of the transport pickup listing
    if (this.transportPickupListingComponent) {
      this.transportPickupListingComponent.onTransportPickupUpdated();
    }
  }
}
